import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useCourseIncomplete } = getCRUDHooks({
  entityName: 'courseIncomplete',
  create: ({ userId, courseId }) =>
    clientApi.getOCClient().helpers.learningActivity.courses.markAsIncomplete(userId, courseId),
});

export default useCourseIncomplete;
